// import { CommonModule } from '@angular/common';
// import { Component, signal } from '@angular/core';

// @Component({
// selector: 'app-home-comp1',
// standalone: true,
// imports: [CommonModule],
// templateUrl: './homecomp1.component.html',
// styleUrls: ['./homecomp1.component.scss']
// })
// export class Homecomp1Component {

//   features = [
//     { icon: 'bi bi-cash-stack', title: 'Gestión de Ventas', desc: 'Control de caja rápida y eficiente para cualquier tipo de negocio.' },
//     { icon: 'bi bi-lightning-fill', title: 'Facturación Electrónica', desc: 'Emisión de boletas y facturas conectadas directamente a SUNAT.' },
//     { icon: 'bi bi-box-seam', title: 'Control de Inventarios', desc: 'Manejo de stock en tiempo real con alertas de reposición.' }
//   ];

//   planes = [
//     { nombre: 'Emprendedor', precio: '49', popular: false, items: ['Hasta 100 comprobantes', '1 Usuario', 'Soporte Básico', 'Reportes Diarios'] },
//     { nombre: 'Negocio', precio: '99', popular: true, items: ['Comprobantes Ilimitados', '3 Usuarios', 'Soporte Premium 24/7', 'Control de Inventario'] },
//     { nombre: 'Corporativo', precio: '199', popular: false, items: ['Comprobantes Ilimitados', 'Multialmacén', 'API Integración', 'Usuarios Ilimitados'] }
//   ];

//   sistemaActivo = signal('facturacion');

//   contactarWhatsApp(plan: string) {
//     const telefono = '51900000000'; // Reemplaza con tu número
//     const mensaje = encodeURIComponent(`Hola Centrix! Estoy interesado en el Plan ${plan} del sistema de ventas.`);
//     window.open(`https://wa.me/${telefono}?text=${mensaje}`, '_blank');
//   }

//   cambiarSistema(id: string) {
//     this.sistemaActivo.set(id);
//   }

//   solicitarDemo() {
//     const msg = `Hola, solicito demo del sistema: ${this.sistemaActivo()}`;
//     window.open(`https://wa.me/51966637291?text=${encodeURI(msg)}`, '_blank');
//   }

// }

import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy, Output, EventEmitter, inject } from '@angular/core';
import { AppConstants } from '../../../../core/common/app-constants';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home-comp1',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './homecomp1.component.html',
  styleUrls: ['./homecomp1.component.scss']
})
export class Homecomp1Component /*implements OnInit, OnDestroy*/ {
  private router = inject(Router);

  servicios(){
    this.router.navigate([AppConstants.routes.SERVICIOS]);
  }

  saberMas(){
    this.router.navigate([AppConstants.routes.SABERMAS]);
  }
  // @Output() sistemaCambiado = new EventEmitter<string>();
  
  // slides = [
  //   { id: 'facturacion', title: 'Facturación Electrónica', desc: 'Sistema de ventas completo y legal.', img: 'assets/imagenes/page_ventas_init.png' },
  //   { id: 'qr', title: 'Web Encuéntrame QR', desc: 'Protege lo que más quieres con tecnología QR.', img: 'assets/imagenes/page_encuentrame_init.png' },
  //   { id: 'ecommerce', title: 'Ventas Online', desc: 'Tu tienda virtual con administrador interno.', img: 'assets/imagenes/page_ecommerce_init.png' }
  // ];

  // currentIndex = 0;
  // interval: any;

  // ngOnInit() {
  //   this.startAutoPlay();
  // }

  // startAutoPlay() {
  //   this.interval = setInterval(() => {
  //     this.nextSlide();
  //   }, 5000);
  // }

  // nextSlide() {
  //   this.currentIndex = (this.currentIndex + 1) % this.slides.length;
  //   this.sistemaCambiado.emit(this.slides[this.currentIndex].id);
  // }

  // setSlide(index: number) {
  //   this.currentIndex = index;
  //   this.sistemaCambiado.emit(this.slides[index].id);
  //   clearInterval(this.interval);
  //   this.startAutoPlay();
  // }

  // ngOnDestroy() {
  //   if (this.interval) clearInterval(this.interval);
  // }
}